import React from 'react';
import useStyle from './productLinePanier.style';
import { IconButton } from '../../../atoms/Buttons/IconButton';
import { Select } from '../../../atoms/Inputs/Select';

export interface ProductLinePanierViewProps {
  name: string;
  price: string;
  reference: number;
  quantity: number;
  onClickViewMore: () => void;
  onClickTrash: () => void;
  hideButtons: boolean;
  editableQuantity?: boolean;
  defaultQuantity?: number | string;
  onChangeQuantity?: (e: any) => void;
}

export const ProductLinePanierView = ({
  name,
  reference,
  price,
  quantity,
  onClickViewMore,
  onClickTrash,
  hideButtons,
  editableQuantity,
  defaultQuantity,
  onChangeQuantity
}: ProductLinePanierViewProps) => {
  const classes = useStyle();

  return (
    <div className={classes.root}>
      <div className={classes.line1}>
        <p className={classes.nom}>
          {reference} - {name}
        </p>
        <p className={classes.infos}>{`${price}€`}</p>
      </div>
      <div className={classes.line2}>
        {editableQuantity ? (
          <div style={{ display: 'flex', gap: '5px', alignItems: 'center' }}>
            <p>Quantité:</p>
            <Select
              maxValue={400}
              onChange={onChangeQuantity}
              initialOptionName={defaultQuantity}
            />
          </div>
        ) : (
          <p className={classes.infos}>{`Quantité: ${quantity}`}</p>
        )}

        {!hideButtons && (
          <div className={classes.line3}>
            <IconButton
              icon={'MoreAbout'}
              variant={'backless'}
              onClick={onClickViewMore}
            />
            <IconButton
              icon={'Trash'}
              color={'#D12B3F'}
              variant={'backless'}
              onClick={onClickTrash}
            />
          </div>
        )}
      </div>
    </div>
  );
};
